import { render, staticRenderFns } from "./JacRegionBoardMembersList.vue?vue&type=template&id=7b8ee788"
import script from "./JacRegionBoardMembersList.vue?vue&type=script&lang=js"
export * from "./JacRegionBoardMembersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports